import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ROLE_HOME, UserRole } from '../models/user-role.enum';
import { AuthService } from '../services/auth.service';
import { SessionService } from '../services/session.service';

/**
 * Restricts a route to specific roles. Attach the allowed roles on the route:
 * `{ path: '', canActivate: [roleGuard], data: { roles: [UserRole.Student] } }`
 */
export const roleGuard: CanActivateFn = (route) => {
  const session = inject(SessionService);
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.needsActivation()) {
    return router.createUrlTree(['/auth/activate']);
  }

  const allowed = (route.data['roles'] as UserRole[] | undefined) ?? [];
  if (allowed.length === 0 || session.hasRole(...allowed)) {
    return true;
  }

  const role = session.role();
  return router.createUrlTree([role ? ROLE_HOME[role] : '/auth/login']);
};
